import produce, { immerable } from "immer";
export class Time {
  [immerable] = true;
  hour: number;
  minute: number;
  second: number;

  constructor(hour?: number, minute?: number, second?: number) {
    this.hour = hour ?? 0;
    this.minute = minute ?? 0;
    this.second = second ?? 0;
  }

  format() {
    return `${this.hour}:${this.minute}:${this.second}`;
  }

  totalSeconds() {
    return this.hour * 60 * 60 + this.minute * 60 + this.second;
  }

  updateHour(hour: number) {
    return produce(this, (draft) => {
      draft.hour = hour;
    });
  }

  updateMinute(minute: number) {
    return produce(this, (draft) => {
      draft.minute = minute;
    });
  }

  updateSecond(second: number) {
    return produce(this, (draft) => {
      draft.second = second;
    });
  }
}
